import axios from 'axios'
import { wrapApiError } from '@/utils/apiError'

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:8000'

export const communityApi = {
  async createCommunity(communityData) {
    try {
      const response = await axios.post(`${API_URL}/communities`, communityData);
      return response.data;
    } catch (error) {
      throw wrapApiError(error, 'Failed to create community', 'No response from server');
    }
  },

  async getCommunitySettings(communityId) {
    try {
      const [communityResponse, settingsResponse] = await Promise.all([
        axios.get(`${API_URL}/communities/${communityId}`),
        axios.get(`${API_URL}/communities/${communityId}/settings`)
      ]);
      return {
        community: communityResponse.data,
        settings: settingsResponse.data
      };
    } catch (error) {
      throw wrapApiError(error, 'Failed to fetch community settings', 'No response from server');
    }
  },

  async updateCommunitySettings(communityId, { community, settings }) {
    try {
      const [communityResponse, settingsResponse] = await Promise.all([
        axios.put(`${API_URL}/communities/${communityId}`, community),
        axios.put(`${API_URL}/communities/${communityId}/settings`, settings)
      ]);
      return {
        community: communityResponse.data,
        settings: settingsResponse.data
      };
    } catch (error) {
      throw wrapApiError(error, 'Failed to save community settings', 'No response from server');
    }
  },

  // Marks the community's cached affiliate links revoked; fresh links are
  // generated lazily on each product's next send. Manually pasted links are
  // never touched. Pass trackingId to scope the revoke to one tracking id.
  async revokeAffiliateLinks(communityId, trackingId = null) {
    try {
      const response = await axios.post(
        `${API_URL}/communities/${communityId}/settings/affiliate-links/revoke`,
        { tracking_id: trackingId }
      );
      return response.data; // { revoked: <count> }
    } catch (error) {
      throw wrapApiError(error, 'Failed to revoke affiliate links', 'No response from server');
    }
  },

  async getCommunities() {
    try {
      const response = await axios.get(`${API_URL}/communities`);
      return response.data;
    } catch (error) {
      throw wrapApiError(error, 'Failed to fetch communities', 'No response from server');
    }
  },

  async getCommunity(communityId) {
    try {
      const response = await axios.get(`${API_URL}/communities/${communityId}`);
      return response.data;
    } catch (error) {
      throw wrapApiError(error, 'Failed to fetch the community', 'No response from server');
    }
  },

  async updateCommunity(communityId, communityData) {
    try {
      const response = await axios.put(`${API_URL}/communities/${communityId}`, communityData);
      return response.data;
    } catch (error) {
      throw wrapApiError(error, 'Failed to update the community', 'No response from server');
    }
  },

  async deleteCommunity(communityId) {
    try {
      const response = await axios.delete(`${API_URL}/communities/${communityId}`);
      return response.data;
    } catch (error) {
      throw wrapApiError(error, 'Failed to delete the community', 'No response from server');
    }
  },

  async getCommunitySettingsOnly(communityId) {
    try {
      const response = await axios.get(`${API_URL}/communities/${communityId}/settings`);
      return response.data;
    } catch (error) {
      throw wrapApiError(error, 'Failed to fetch community settings', 'No response from server');
    }
  }
}


export default communityApi 